import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Tabs } from "antd";
import _ from "lodash";
import { Table, Switch } from "antd";

import ModalComponent from "components/modalComponent/ModalComponent";

const TabPane = Tabs.TabPane;
const tabDevices = ["DESKTOP", "TABLETTE", "MOBILE"];

class ModalClientRights extends PureComponent {
	state = {
		tabActiveKey: tabDevices[0],
	};
	// updateClientServiceAcl = (serviceId, aclId) => {
	// 	this.props.onChangeSelectAclServiceClient(serviceId, aclId);
	// };

	columns = () => [
		{
			title: "",
			dataIndex: "label",
			key: "label",
			render: text => <span>{text}</span>,
		},
		{
			title: "CRÉATION",
			dataIndex: "age",
			key: "age",
			render: (text, record) => {
				const result = this.props.userClientServices.filter(
					service => service.id === record.id
				);
				const checkedValue = _.isEmpty(result)
					? false
					: result[0].access.creation === 1
					? true
					: false;

				return (
					<Switch
						checked={checkedValue}
						onChange={switchStatus =>
							this.props.updateClientServiceAccess(
								switchStatus,
								record.id,
								"creation"
							)
						}
					/>
				);
			},
		},
		{
			title: "MODIFICATION",
			dataIndex: "address",
			key: "address",
			render: (text, record) => {
				const result = this.props.userClientServices.filter(
					service => service.id === record.id
				);
				const checkedValue = _.isEmpty(result)
					? false
					: result[0].access.modification === 1
					? true
					: false;

				return (
					<Switch
						checked={checkedValue}
						onChange={switchStatus =>
							this.props.updateClientServiceAccess(
								switchStatus,
								record.id,
								"modification"
							)
						}
					/>
				);
			},
		},
		{
			title: "CONSULTATION",
			key: "actionconsultation",
			render: (text, record) => {
				const result = this.props.userClientServices.filter(
					service => service.id === record.id
				);
				const checkedValue = _.isEmpty(result)
					? false
					: result[0].access.consultation === 1
					? true
					: false;

				return (
					<Switch
						checked={checkedValue}
						onChange={switchStatus =>
							this.props.updateClientServiceAccess(
								switchStatus,
								record.id,
								"consultation"
							)
						}
					/>
				);
			},
		},
		{
			title: "SUPPRESSION",
			key: "actionsuppression",
			render: (text, record) => {
				const result = this.props.userClientServices.filter(
					service => service.id === record.id
				);
				const checkedValue = _.isEmpty(result)
					? false
					: result[0].access.suppression === 1
					? true
					: false;

				return (
					<Switch
						checked={checkedValue}
						onChange={switchStatus =>
							this.props.updateClientServiceAccess(
								switchStatus,
								record.id,
								"suppression"
							)
						}
					/>
				);
			},
		},
		{
			title: "TÉLÉCHARGEMENT",
			key: "action",
			render: (text, record) => {
				const result = this.props.userClientServices.filter(
					service => service.id === record.id
				);
				const checkedValue = _.isEmpty(result)
					? false
					: result[0].access.download === 1
					? true
					: false;

				return (
					<Switch
						checked={checkedValue}
						onChange={switchStatus =>
							this.props.updateClientServiceAccess(
								switchStatus,
								record.id,
								"download"
							)
						}
					/>
				);
			},
		},
		{
			title: "EXPORT",
			key: "action",
			render: (text, record) => {
				const result = this.props.userClientServices.filter(
					service => service.id === record.id
				);
				const checkedValue = _.isEmpty(result)
					? false
					: result[0].access.export === 1
					? true
					: false;

				return (
					<Switch
						checked={checkedValue}
						onChange={switchStatus =>
							this.props.updateClientServiceAccess(
								switchStatus,
								record.id,
								"export"
							)
						}
					/>
				);
			},
		},
	];

	closeModalClientRights = () => {
		this.setState({ tabActiveKey: tabDevices[0] });
		this.props.closeModal();
	};

	render() {
		const { showModal, user, client, servicesList } = this.props;
		const { tabActiveKey } = this.state;

		return (
			<ModalComponent
				title={"GESTION DES DROITS"}
				showModal={showModal}
				closeModal={this.closeModalClientRights}
				width={"80%"}
			>
				<div className="p-mrg-bot p-clr-mdg">
					{user.email}
					{` - `}
					{client.label}
				</div>
				<div>
					<Tabs
						activeKey={tabActiveKey}
						onChange={activeKey =>
							this.setState({
								tabActiveKey: tabDevices[tabDevices.indexOf(activeKey)],
							})
						}
					>
						{tabDevices.map(device => {
							const servicesListFiltered = servicesList.filter(service => {
								return (
									_.toLower(_.startCase(service.scope)) === _.toLower(device)
								);
							});

							return (
								<TabPane tab={device} key={device}>
									<Table
										columns={this.columns()}
										dataSource={servicesListFiltered}
									/>
								</TabPane>
							);
						})}
					</Tabs>
				</div>
			</ModalComponent>
		);
	}
}

ModalClientRights.propTypes = {
	showModal: PropTypes.boolean,
	closeModal: PropTypes.function,
	user: PropTypes.object,
	client: PropTypes.object,
	servicesList: PropTypes.array,
	aclList: PropTypes.array,
	userClientServices: PropTypes.array,
	// onChangeSelectAclServiceClient: PropTypes.function,
};

export default ModalClientRights;



// WEBPACK FOOTER //
// src/containers/admin/users/ModalClientRights.js